import { useContext } from 'react';
import { Context } from 'context';

/**
 * Returns a group-specific UI label from Strapi CMS config.
 * Falls back to the provided default if no override is found for the given group.
 *
 * @param {string} key - The config key (e.g. 'activation_fee')
 * @param {string} defaultLabel - Fallback label if no Strapi override exists
 * @param {string} groupId - The group ID to resolve the label for
 * @returns {string} - The resolved label
 *
 * @example
 * const label = useGroupUiLabel('activation_fee', 'Activation Cost', group_id);
 */
const useGroupUiLabel = (key, defaultLabel, groupId) => {
  const { state: { groupUiConfigs = {} } } = useContext(Context);
  return groupUiConfigs[groupId]?.[key] || defaultLabel;
};

export default useGroupUiLabel;
